import React from 'react'
import './index.less'

export interface Props {
  title?: string
}

export default function ({ title = '哎呀！网络开了小差' }: Props) {
  const [pTitle, setPTitle] = React.useState(title)
  const reload = React.useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <div className="kem__load-error">
      <div className="picture" />
      <p className="title">{pTitle}</p>
      <div className="link" onClick={reload}>
        请点击页面刷新
      </div>
    </div>
  )
}
